<div class="statusReservationType__cont">
  <app-ds-tag-status
    [type]="tagStatusType"
    [size]="tagStatusSize.RG"
    [title]="('USER_HISTORY_MODULE.STATUS.' + (status | uppercase)) | transloco">
  </app-ds-tag-status>
</div>